export default theme => ({
  icon: {
    marginRight: 5,
  },
});
